import { render, staticRenderFns } from "./edit-special-data.vue?vue&type=template&id=6c81d3d2"
import script from "./edit-special-data.vue?vue&type=script&lang=ts"
export * from "./edit-special-data.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports